import SalaryService from '@/services/salary.service.js'

const state = {
  payments: [],
  stats: { pendingPayments: 0, totalPaid: 0 },
  loading: false
}

const getters = {
  payments: state => state.payments,
  stats: state => state.stats,
  loading: state => state.loading
}

const actions = {
  async fetchSalaryPayments ({ commit, dispatch }, { month, year }) {
    try {
      commit('SET_LOADING', true)
      const response = await SalaryService.getSalaryPayments(month, year)
      const data = response.payload || response
      commit('SET_PAYMENTS', data.records || [])
      commit('SET_STATS', data.stats || {})
      return data
    } catch (error) {
      dispatch('notification/showError', error.message || 'Failed to load salary payments', { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async recordSalaryExpense ({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await SalaryService.recordExpense(payload)
      dispatch('notification/showSuccess', response.payload?.message || 'Salary expense recorded successfully', { root: true })
      return response
    } catch (error) {
      dispatch('notification/showError', error.message || 'Failed to record salary expense', { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async addSalaryPayment ({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await SalaryService.addPayment(payload)
      dispatch('notification/showSuccess', response.payload?.message || 'Salary payment recorded successfully', { root: true })
      return response
    } catch (error) {
      dispatch('notification/showError', error.message || 'Failed to record salary payment', { root: true })
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const mutations = {
  SET_PAYMENTS (state, records) {
    state.payments = Array.isArray(records) ? records : []
  },
  SET_STATS (state, stats) {
    state.stats = {
      pendingPayments: stats.pendingPayments || 0,
      totalPaid: stats.totalPaid || 0
    }
  },
  SET_LOADING (state, value) {
    state.loading = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
